<ub-card>
  <div title>
    <h4>{{ bookingItemOption.title }} - {{ bookingItemOption.state.name }}</h4>
  </div>
  <div content *easLoader="loadingState">
    @for (table of tables; track table) {
      <div>
        <eas-table [table]="table"></eas-table>
      </div>
    }
  </div>
</ub-card>
